import { memo } from 'react';
import { isNil } from 'lodash';
// Import UI components
import { Empty } from '@geneui/components';
// Import components
import DynamicSegmentListItem from './DynamicSegmentListItem';
// Import container
import { UIHashComparisonContainer } from './UIHashContainers';

interface Props {
    list?: AnyObject | AnyObject[];
    handleChangeActiveColumnsList?: (hashKey: string, displayName: string) => void;
    full?: boolean;
    selected?: Nullable<string>;
    setReadOnlyFilterContainer?: (value: boolean) => void;
}

const DynamicSegmentList: React.FC<Props> = (props) => {
    const { list, handleChangeActiveColumnsList, full, selected, setReadOnlyFilterContainer } = props;

    const itemClickHandler = (hashKey, displayName) => {
        setReadOnlyFilterContainer?.(false);
        handleChangeActiveColumnsList?.(hashKey, displayName);
    };

    return list instanceof UIHashComparisonContainer ? null : (
        <ul className={`crm-dynamic-segment-list ${!full ? 'crm-closed' : ''}`}>
            <div className="crm-scroll-holder">
                <div className="crm-scrollable-container">
                    {!isNil(list?.[0]) ? (
                        list?.map((elem, index) => {
                            const {
                                displayName,
                                colorUI,
                                uiType,
                                description,
                                hashKey,
                                hashType,
                                comparison,
                                segmentationFilterId,
                                schemaDeps,
                            } = elem;
                            return (
                                <DynamicSegmentListItem
                                    key={index}
                                    text={displayName}
                                    color={colorUI}
                                    uiType={uiType}
                                    full={full}
                                    description={description}
                                    type={hashType}
                                    selected={selected === displayName}
                                    handleClick={() => itemClickHandler(hashKey, displayName)}
                                    comparisonIconType={comparison}
                                    segmentationFilterId={segmentationFilterId}
                                    schemaDeps={schemaDeps}
                                />
                            );
                        })
                    ) : (
                        <Empty
                            appearance="greyscale"
                            withImage
                            title={'No Result'}
                            subTitle="Duis tempus justo nec nunc accumsan eleifend."
                        />
                    )}
                </div>
            </div>
        </ul>
    );
};

export default memo(DynamicSegmentList);
